var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { ricosBICallbacks } from "./ricosBICallbacks";
function biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, _experiments) {
  const _a = biSettings, { biCallbacks, postId: settingsPostId, contentId: settingsContentId } = _a, rest = __objRest(_a, ["biCallbacks", "postId", "contentId"]);
  const logger = ricosBICallbacks(__spreadProps(__spreadValues({}, rest), {
    postId: settingsPostId || settingsContentId || "",
    appDefId,
    metaSiteId,
    wixRicosVersion,
    ricosVersion
  }));
  return {
    helpers: {
      onModalAction: (args) => {
        var _a2;
        logger.onModalAction(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onModalAction) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onPluginAdd: (pluginId, entryPoint, version, contentId) => {
        var _a2;
        logger.onPluginAdd(pluginId, entryPoint, version, contentId);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginAdd) == null ? void 0 : _a2.call(biCallbacks, pluginId, entryPoint, version, contentId);
      },
      onPluginAddStep: (args) => {
        var _a2;
        logger.onPluginAddStep(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginAddStep) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onPluginAddSuccess: (pluginId, entryPoint, params, version, contentId) => {
        var _a2;
        logger.onPluginAddSuccess(pluginId, entryPoint, params, version, contentId);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginAddSuccess) == null ? void 0 : _a2.call(biCallbacks, pluginId, entryPoint, params, version, contentId);
      },
      onPluginDelete: (args) => {
        var _a2;
        logger.onPluginDelete(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginDelete) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onPublish: (postId, pluginsCount, pluginsDetails, version, contentId) => {
        var _a2;
        const appliedContentId = postId || settingsPostId || settingsContentId;
        logger.onPublish(appliedContentId, pluginsCount, pluginsDetails, version, contentId);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPublish) == null ? void 0 : _a2.call(
          biCallbacks,
          appliedContentId,
          pluginsCount,
          pluginsDetails,
          version,
          contentId
        );
      },
      onMenuLoad: (args) => {
        var _a2;
        logger.onMenuLoad(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onMenuLoad) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onPluginModalOpened: (args) => {
        var _a2;
        logger.onPluginModalOpened(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginModalOpened) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onViewerAction: (pluginId, actionName, value, contentId, partialNode) => {
        var _a2;
        logger.onViewerAction(pluginId, actionName, value, contentId, partialNode);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onViewerAction) == null ? void 0 : _a2.call(biCallbacks, pluginId, actionName, value, contentId, partialNode);
      },
      onViewerLoaded: (args) => {
        var _a2;
        logger.onViewerLoaded(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onViewerLoaded) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onOpenEditorSuccess: (version, toolbarType, contentId) => {
        var _a2;
        logger.onOpenEditorSuccess(version, toolbarType, contentId);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onOpenEditorSuccess) == null ? void 0 : _a2.call(biCallbacks, version, toolbarType, contentId);
      },
      onContentEdited: (args) => {
        var _a2;
        logger.onContentEdited(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onContentEdited) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onInlineToolbarOpen: (args) => {
        var _a2;
        logger.onInlineToolbarOpen(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onInlineToolbarOpen) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onToolbarButtonClick: (args) => {
        var _a2;
        logger.onToolbarButtonClick(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onToolbarButtonClick) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onKeyboardShortcutAction: (args) => {
        var _a2;
        logger.onKeyboardShortcutAction(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onKeyboardShortcutAction) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onMediaUploadStart: (correlationId, pluginId, fileSize, mediaType, version, contentId) => {
        var _a2;
        logger.onMediaUploadStart(correlationId, pluginId, fileSize, mediaType, version, contentId);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onMediaUploadStart) == null ? void 0 : _a2.call(
          biCallbacks,
          correlationId,
          pluginId,
          fileSize,
          mediaType,
          version,
          contentId
        );
      },
      onMediaUploadEnd: (correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version, contentId) => {
        var _a2;
        logger.onMediaUploadEnd(
          correlationId,
          pluginId,
          duration,
          fileSize,
          mediaType,
          isSuccess,
          errorType,
          version,
          contentId
        );
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onMediaUploadEnd) == null ? void 0 : _a2.call(
          biCallbacks,
          correlationId,
          pluginId,
          duration,
          fileSize,
          mediaType,
          isSuccess,
          errorType,
          version,
          contentId
        );
      },
      onPluginAction: (eventName, params) => {
        var _a2;
        logger.onPluginAction(eventName, params);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginAction) == null ? void 0 : _a2.call(biCallbacks, eventName, params);
      },
      onPluginsPopOverTabSwitch: (args) => {
        var _a2;
        logger.onPluginsPopOverTabSwitch(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginsPopOverTabSwitch) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onPluginsPopOverClick: (args) => {
        var _a2;
        logger.onPluginsPopOverClick(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onPluginsPopOverClick) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      onChangePluginSettings: (args) => {
        var _a2;
        logger.onChangePluginSettings(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.onChangePluginSettings) == null ? void 0 : _a2.call(biCallbacks, args);
      },
      mediaPluginsDetails: (args) => {
        var _a2;
        logger.mediaPluginsDetails(args);
        (_a2 = biCallbacks == null ? void 0 : biCallbacks.mediaPluginsDetails) == null ? void 0 : _a2.call(biCallbacks, args);
      }
    }
  };
}
export {
  biStrategy
};
//# sourceMappingURL=biStrategy.js.map
